import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex rounded-md shadow-sm bg-white dark:border-gray-200 dark:border dark:bg-gray-800" }
const _hoisted_2 = { class: "flex items-center justify-center w-16 text-sm font-medium text-white bg-white shrink-0 rounded-l-md guide-img-container" }
const _hoisted_3 = ["href", "alt", "title"]
const _hoisted_4 = ["src", "alt", "title"]
const _hoisted_5 = { class: "flex items-center justify-between flex-1 truncate bg-white border-t border-b border-r border-gray-200 rounded-r-md" }
const _hoisted_6 = { class: "flex-1 px-4 py-2 text-sm truncate" }
const _hoisted_7 = ["href", "alt", "title"]
const _hoisted_8 = { class: "text-clay-800" }
const _hoisted_9 = { class: "" }
const _hoisted_10 = { class: "sr-only" }


import {AuthorDto} from "@/dtos";


export default /*@__PURE__*/_defineComponent({
  __name: 'WriterCardMinimal',
  props: {
    writer: {}
  },
  setup(__props: any) {

// @ts-ignore
const props = __props
const writer: AuthorDto = props.writer;


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("a", {
        class: "font-medium text-gray-900 hover:text-gray-600",
        href: `/${_unref(writer).urlSlug}`,
        alt: _unref(writer).name,
        title: _unref(writer).name
      }, [
        _createElementVNode("img", {
          src: _unref(writer).imageUrl,
          alt: `${_unref(writer).name} logo`,
          title: _unref(writer).name
        }, null, 8, _hoisted_4)
      ], 8, _hoisted_3)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("a", {
          class: "font-medium text-gray-900 hover:text-gray-600",
          href: `/${_unref(writer).urlSlug}`,
          alt: _unref(writer).name,
          title: _unref(writer).name
        }, _toDisplayString(_unref(writer).name), 9, _hoisted_7),
        _createElementVNode("p", _hoisted_8, [
          _createElementVNode("em", _hoisted_9, _toDisplayString(_unref(writer).jobTitles?.join(', ')), 1),
          _createElementVNode("span", _hoisted_10, _toDisplayString(_unref(writer).jobTitles?.join(', ')) + ", ", 1)
        ])
      ])
    ])
  ]))
}
}

})